// ============================================================
// COVRFLY® — Comparador de Acabados Slider v2.0.0
// JS Relocation + Drag directo + Auto-detect modelo
// ============================================================
(function() {
  'use strict';

  var wrapper = document.querySelector('.cf-compare-wrapper');
  if (!wrapper) return;

  // ─── PASO 1: RELOCATION RESPONSIVE ───
  // Desktop ≥992px: mover a .col-lg-7 (columna izquierda, debajo de galería)
  // Mobile <992px: dejar en la section original (ya está bien posicionado)
  var mq = window.matchMedia('(min-width: 992px)');
  var originalParent = wrapper.parentElement; // .cf-compare-section

  function relocate() {
    if (mq.matches) {
      // Desktop: mover a col-lg-7, después de la galería sticky
      var mediaContainer = document.querySelector('.product__media_container');
      if (mediaContainer && mediaContainer.parentElement) {
        mediaContainer.parentElement.appendChild(wrapper);
      }
    } else {
      // Mobile: devolver a la section original
      if (originalParent && wrapper.parentElement !== originalParent) {
        originalParent.appendChild(wrapper);
      }
    }
    // Revelar después de mover (anti-FOUC)
    wrapper.style.opacity = '1';
  }

  relocate();
  if (mq.addEventListener) {
    mq.addEventListener('change', relocate);
  } else {
    mq.addListener(relocate);
  }

  // ─── PASO 2: VERIFICAR ACABADO ───
  var slider = wrapper.querySelector('.cf-slider');
  if (!slider) return;

  var acabadoSelect = document.querySelector('select[name="options[Acabado]"]');
  if (!acabadoSelect || acabadoSelect.options.length < 2) {
    wrapper.style.display = 'none';
    return;
  }

  var handle = slider.querySelector('.cf-slider-handle');
  var line = slider.querySelector('.cf-slider-line');
  var mate = slider.querySelector('.cf-slider-mate');
  var glossy = slider.querySelector('.cf-slider-glossy');

  if (!handle || !line || !mate || !glossy) return;

  // ─── PASO 3: DRAG DIRECTO 1:1 ───
  var dragging = false;
  var sliderRect = null;

  function setPos(pct) {
    pct = Math.max(10, Math.min(90, pct));
    handle.style.left = pct + '%';
    line.style.left = pct + '%';
    mate.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
  }

  // Haptic feedback al cruzar el centro (Android)
  var lastSide = 'center';
  function checkHaptic(pct) {
    var side = pct < 48 ? 'left' : pct > 52 ? 'right' : 'center';
    if (side !== lastSide && side === 'center' && navigator.vibrate) {
      navigator.vibrate(5);
    }
    lastSide = side;
  }

  slider.addEventListener('pointerdown', function(e) {
    dragging = true;
    sliderRect = slider.getBoundingClientRect(); // Cache UNA vez
    slider.classList.add('is-dragging', 'cf-touched');
    slider.setPointerCapture(e.pointerId);
    var pct = ((e.clientX - sliderRect.left) / sliderRect.width) * 100;
    setPos(pct);
    e.preventDefault();
  });

  slider.addEventListener('pointermove', function(e) {
    if (!dragging) return;
    var pct = ((e.clientX - sliderRect.left) / sliderRect.width) * 100;
    pct = Math.max(10, Math.min(90, pct));
    setPos(pct); // DIRECTO, sin spring
    checkHaptic(pct);
  });

  slider.addEventListener('pointerup', function() {
    dragging = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('lostpointercapture', function() {
    dragging = false;
    slider.classList.remove('is-dragging');
  });

  // ─── PASO 4: AUTO-DETECT MODELO iPhone/Samsung ───
  var modelSelect = document.querySelector('select[name="options[Elige tu Modelo]"]')
    || document.querySelector('select[name="options[Modelo]"]');

  function updateMockups() {
    if (!modelSelect) return;
    var val = modelSelect.value.toLowerCase();
    var isSamsung = val.indexOf('samsung') !== -1 || val.indexOf('galaxy') !== -1;

    var newGlossySrc = wrapper.getAttribute(isSamsung ? 'data-samsung-glossy' : 'data-iphone-glossy');
    var newMateSrc = wrapper.getAttribute(isSamsung ? 'data-samsung-mate' : 'data-iphone-mate');

    if (!newGlossySrc || !newMateSrc) return;

    // Crossfade
    glossy.style.opacity = 0;
    mate.style.opacity = 0;

    setTimeout(function() {
      glossy.src = newGlossySrc;
      mate.src = newMateSrc;
      glossy.style.opacity = 1;
      mate.style.opacity = 1;
    }, 150);
  }

  // ─── PASO 4.5: ESCONDER SI MODELO NO TIENE MATE ───
  function checkMateAvailability() {
    if (!modelSelect) return;
    var modelVal = modelSelect.value.toLowerCase().trim();
    var jsonEl = document.querySelector('[data-cf-product-variants]');
    if (!jsonEl) return; // Sin datos → dejar visible (fallback seguro)

    try {
      var variants = JSON.parse(jsonEl.textContent);
      var hasMate = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((v.option1 || '').toLowerCase().trim() === modelVal &&
            (v.option3 || '').toLowerCase().indexOf('matte') !== -1) {
          hasMate = true;
          break;
        }
      }

      if (hasMate) {
        wrapper.classList.remove('cf-compare-hidden');
      } else {
        wrapper.classList.add('cf-compare-hidden');
      }
    } catch (e) {
      // Error parseando JSON → dejar visible
    }
  }

  if (modelSelect) {
    modelSelect.addEventListener('change', function() {
      updateMockups();
      checkMateAvailability();
    });
    document.addEventListener('covrfly:model-changed', function() {
      updateMockups();
      checkMateAvailability();
    });
    updateMockups();
    checkMateAvailability();
  }

  // ─── PASO 5: SHOPIFY EDITOR SUPPORT ───
  document.addEventListener('shopify:section:load', function() {
    relocate();
  });

  console.log('[COVRFLY Compare] v2.0.0 — relocatable');
})();
